import { create } from 'zustand';

// ---------------------------------------------------------------------------
// RevocationStore
//
// Tracks a resource whose access was revoked while the user was viewing it.
// Set by entityEventHandler when a DELETED event arrives for the currently-
// viewed document or collection. Consumed by RevocationModal in the app root.
//
// Also tracks the currently-viewed resource ID so that entityEventHandler
// (which runs outside React) can compare against it without touching the
// session state context.
// ---------------------------------------------------------------------------

interface RevokedResource {
  id: string;
  title: string;
}

interface RevocationState {
  revokedResource: RevokedResource | null;
  /** ID of the resource currently open in the focused panel (null if none). */
  viewedResourceId: string | null;
  setRevoked: (resource: RevokedResource) => void;
  clearRevoked: () => void;
  setViewedResourceId: (id: string | null) => void;
}

export const useRevocationStore = create<RevocationState>()((set) => ({
  revokedResource: null,
  viewedResourceId: null,
  setRevoked: (resource) => set({ revokedResource: resource }),
  clearRevoked: () => set({ revokedResource: null }),
  setViewedResourceId: (id) => set({ viewedResourceId: id }),
}));
